import React, { Component } from 'react';
import { browserHistory } from 'react-router';

import Pagination from './../../../../components/Pagination';
import Image from './../../../../components/ZUILib/Image';
import InputButton from './../../../../components/ZUILib/InputButton';
import commonUtil from './../../../../utils/commonUtil';
import WapEventSearchResultCard from './WapEventSearchResult';
import { ReorderListBtn } from './ReorderListBtn';
import RadioDropDown from '../../../../components/ZUILib/RadioDropDown';
import _ from 'lodash';
import EventIcon from '../../../../components/EventIcon/EventIcon';
import { eventTypeIconsObject } from '../../../../components/NewHeader/Header/svgIcons';
import { calendarSvgIcon } from '../../../createEvent/page/SelectMesaType/components/svgIcons';

const channel = commonUtil.getChannel();

const applicationRoutes = commonUtil.getApplicationRoutes();
const headerTableResults = ['Evento', 'Nombres', 'Fecha', 'Listas'];
class EventTable extends Component {
    constructor(props) {
    super(props);
    this.currentPage = 1;
  }
  openPage = (id, eventCategory, eventType) => {
    const dataLayer = {
      event: 'comprar_para_mesa_de_regalos',
      seccion: 'Mesa de regalos',
      phase: 'Busqueda de mesa',
      step: 'Seleccion mesa',
      numero_mesa: id,
      tipo: `${eventCategory} | ${eventType}`,
    };
    window.dataLayer.push(dataLayer);
    browserHistory.push(commonUtil.getRouteByParameter(applicationRoutes.giftListGuestView, { eventID: id }));
  }

    onPageChange = (value) => {
    this.currentPage = value;
      this.props.onPageChange(value);
  }

  render() {
    const searchResultData = this.props.searchResultData || [];
    const paginationInfo = this.props.paginationInfo ? {
      totalNoOfRecords: this.props.paginationInfo?.totalNoOfRecords,
      recordsPerPage: this.props.paginationInfo?.recordsPerPage,
      currentPage: this.currentPage,
    } : {};
    const numberToShowEvents = this.props.resultsPerPage;
    // const onPageChange = this.props.onPageChange;
    const eventType = this.props.eventType || '';

    const { totalNoOfRecords, currentPage  } = paginationInfo || 0;
    const valuePerPage = numberToShowEvents * currentPage;

    const showResultsPerPage = (valuePerPage >= +totalNoOfRecords)
      ? +totalNoOfRecords
      : valuePerPage;
    const PriceBasedSorting = {
      options: [{
        id: 'asc',
        value: 'Fecha más cercana al día de hoy',
        labelResourceId: 'HighToLow',
        disabled: false,
      },
      {
        id: 'desc',
        value: 'Fecha más lejana al día de hoy',
        labelResourceId: 'LowToHigh',
        disabled: false,
      },
      ],
    };
    const seeListButton = (eventId, eventCategory, eventTypeCategory) => ({
      type: 'button',
      value: 'Ver lista',
      //iconClass: 'icon-flecha_gruesa_derecha',
      autoFocus: false,
      style: 'outlineSeeMore stylesBrand verListasSearchBtnSize',
      onClickHandler: () => this.openPage(eventId, eventCategory, eventTypeCategory),
    });

    const eventImageAttr = (eventImageURL,altImg) => ({
      src: eventImageURL,
      altImg: altImg || commonUtil.getAssetURL() + '/images/avatar.svg',
      className: 'imageOwnerEvent',
      alt: 'Liverpool',
      width: 'auto',
      height: 'auto',
    });

    const dateFormat = (date) => {
      const f = date ? date.split('/') : "";
      return f ? `${f[2]}/${f[1]}/${f[0]}` : 'N/A';
    };

    const htmlStructure = ({ eventName, category, eventDate, owners }) => (
      <React.Fragment>
        <div>
          <p>{eventName}</p>
          {/* <p>{category}</p> */}
           <p><span className='svg-icon-container'>{(category in eventTypeIconsObject) && eventTypeIconsObject[category]}</span><span>{category}</span></p>
        </div>

        <div>
          {
            owners.map(({ firstName, lastNameOrPaternalName, motherName }) => (
              <p className="celebratedName">
                {firstName} {lastNameOrPaternalName} {motherName}
              </p>))
          }
        </div>

        <div>
          {/* <span>
            <img
              src={`${commonUtil.getAssetURL()}/images/event.svg`}
              width={20}
              height={20}
              alt={'svg'}
            />
          </span> */}
          <span className='icon-address-svg' dangerouslySetInnerHTML={{ __html: calendarSvgIcon }}/>
          <span>{eventDate}</span>
        </div>
      </React.Fragment>
    );

    return (
      <React.Fragment>
        <div className="noOfEventGuest">
          {
            channel == 'wap' && <div style={{ display: "flex", alignItems: "center", justifyContent: 'space-between', padding: '0px 18px' }}>
              <ReorderListBtn
                dataForEventSearchByUserDetails={this.props.dataForEventSearchByUserDetails}
                cleanSearchByUserDetails={this.props.cleanSearchByUserDetails}
                isReorderFn={this.props.isReorderFn}
                typeOrderFn={this.props.typeOrderFn}
                typeOrderKey={this.props.typeOrderKey}
                typeOrderProp={this.props.typeOrderProp}
                typeOrder={this.props.typeOrder}
                eventSearchByUserDetails={this.props.eventSearchByUserDetails}
                eventType={eventType}
                filterTypeEventOrder={this.props.filterTypeEventOrder}
              />
              <p className="numberResults">
                <strong>{`${this.props?.totalNoProducts || 'N/A' } Resultados`}</strong>
              </p>
            </div>
          }
          {
            channel == 'web' && <p className="numberResults" id="search_results_count">
              <strong>{`${showResultsPerPage} de ${this.props.totalNoProducts} `}</strong> resultados
            </p>
          }
          {
            (channel === 'web')
              ? <RadioDropDown
                options={PriceBasedSorting.options}
                selectedOption={this.props.eventDateSortState}
                onChange={this.props.changeEvetDateSort}
                placeholder={`${this.props.eventDateSortState == 'desc' ? 'Fecha más lejana al día de hoy' : 'Fecha más cercana al día de hoy'}`}
              />
              : null
          }
        </div>

        {/* <section className="headerTableResults" style={{ borderBottom: '1px solid #767676' }}>
          <div className="headerTableResults_titles" style={{ color: '#5C5C5C' }}>
            {headerTableResults.map(itemTitle => <span>{ itemTitle }</span>)}
          </div>
        </section> */}

        {
          channel === 'wap' ? (
            <div
              className="contentTableResults"
              style={{ width: '100%', padding: '1.6rem', display: 'flex', flexDirection: 'column', rowGap: '0.8rem' }}
            >
              {searchResultData.map((event, eventIndex) => {
                let eventData = _.find(this.props?.eventCategories, ['name', event?.eventType])
                let themeData = _.find(eventData?.event_themes, ["uid", event?.eventTheme])
                let eventIcon = eventData?.event_icon;
                 if(!event?.eventTheme){
                  themeData = eventData?.event_themes[0] 
                }
                return <WapEventSearchResultCard key={eventIndex} eventId={event.eventId} event={event} eventIcon={eventIcon} onEventClick={this.openPage} themeData={themeData} />
              })}
            </div>
          ) : (
            <section className="tableResultsContainer extraTable" style={{ maxWidth: 'initial', padding: '16px 16px 40px 24px' }}>
              {searchResultData.map(item => {
                let eventData = _.find(this.props?.eventCategories, ['name', item?.eventType])
                let themeData = _.find(eventData?.event_themes, ["uid", item?.eventTheme])
                
                if(!item?.eventTheme){
                  themeData = eventData?.event_themes[0] 
                }
                
                let eventIcon = eventData?.event_icon;
                let eventImage = item?.eventImage || item?.eventImageURL;
                const imageFormat = commonUtil.checkImageURLFormat(eventImage);
          
                return <section className="tableResultsContent">
                  <EventIcon
                      hide_border={true}
                      event_id={item.eventId}
                      event_icon={eventIcon}
                      event_theme_color={themeData?.color_500}
                      event_image={!imageFormat ? eventImage : null}
                      />
                  {htmlStructure({
                    eventName: item.eventName,
                    category: item.eventType,
                    owners: item.owners,
                    eventDate: dateFormat(item.eventDate),
                  })}
                  <div>
                    <InputButton buttonAttr={seeListButton(item.eventId, item.eventCategory, item.eventType)} />
                  </div>
                </section>
              })}
            </section>
          )
        }

        {Number(totalNoOfRecords) > numberToShowEvents
          ? (
            <div className="paginationContainer event_search_pagination">
              <Pagination paginationInfo={paginationInfo} onPageChange={this.onPageChange} />
            </div>
          )
          : null
        }
      </React.Fragment>
    );
  }
}

export default EventTable;
